import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { Button, Card, CardBody } from "reactstrap"
import { useTranslation } from "react-i18next"

const TLVRenderer = ({ nodes }) => {
  const { t } = useTranslation()

  const copyAllData = useCallback(() => {
    const validNodes = nodes.filter(node => node.tag)
    
    const copyText = validNodes.map(node => {
      const tag = node.tag || ''
      const length = node.length || ''
      const value = node.value || ''
      return `${tag} ${length} ${value}`
    }).join('\n')

    navigator.clipboard.writeText(copyText).then(() => {
    }).catch(err => {
      console.error('Failed to copy: ', err)
    })
  }, [nodes])

  const renderNode = (node, index, level = 0) => {
    if (!node.tag) return null

    const nodeId = `${level}-${index}`
    const hasChildren = node.children && node.children.filter(child => child.tag).length > 0
    const indent = level * 20

    return (
      <div key={nodeId} style={{ marginLeft: indent }}>
        <div 
          className="tlv-node"
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '4px 8px',
            borderRadius: '4px',
            marginBottom: '2px'
          }}
        >          
          <div className="tlv-content" style={{ display: 'flex', flex: 1, fontSize: '14px' }}>
            <div className="tlv-tag" style={{ 
              fontWeight: 'bold', 
              minWidth: '40px',
              color: '#013f7c'
            }}>
              {node.tag}
            </div>
            
            <div className="tlv-length" style={{ 
              minWidth: '40px',
              textAlign: 'center',
              margin: '0 15px',
              color: '#34c38f'
            }}>
              {node.length || ''}
            </div>
            
            <div className="tlv-value" style={{ 
              flex: 1,
              wordBreak: 'break-all',
              color: '#74788d'
            }}>
              {node.value || ''}
            </div>
          </div>
        </div>

        {hasChildren && (
          <div style={{ marginLeft: '20px' }}>
            {node.children
              .filter(child => child.tag)
              .map((child, childIndex) => 
                renderNode(child, `${index}-${childIndex}`, level + 1)
              )
            }
          </div>
        )}
      </div>
    )
  }

  if (!nodes || nodes.length === 0) {
    return null
  }

  return (
    <Card style={{ height: '100%', display: 'flex', flexDirection: 'column' , boxShadow: 'none' }}>
      <CardBody style={{ display: 'flex', flexDirection: 'column', height: '100%', padding: 0 }}>
        <div className="d-flex justify-content-between align-items-center mb-3" style={{ flex: '0 0 auto' }}>
          <h5 className="mb-0">{t("tlvParseResult")}</h5>
          <div className="d-flex gap-2">
            <Button
              color="primary"
              onClick={copyAllData}
            >
              {t("copyAll")}
            </Button>
          </div>
        </div>

        <div className="tlv-header" style={{ 
          display: 'flex', 
          fontWeight: 'bold', 
          padding: '4px 8px',
          backgroundColor: '#ffffff',
          borderBottom: '1px solid #dee2e6',
          fontSize: '14px',
          flex: '0 0 auto'
        }}>
          <div style={{ minWidth: '40px', color: '#013f7c' }}>Tag</div>
          <div style={{ minWidth: '40px', textAlign: 'center' , margin: '0 8px', color: '#34c38f' }}>Length</div>
          <div style={{ flex: 1, color: '#74788d', margin: '0 8px' }}>Value</div>
        </div>

        <div style={{ 
          backgroundColor: '#ffffff', 
          border: '1px solid #dee2e6', 
          borderTop: 'none',
          borderRadius: '0 0 4px 4px',
          padding: '0',
          flex: '1 1 auto',
          overflowY: 'auto',
          minHeight: 0
        }}>
          {nodes.filter(node => node.tag).map((node, index) => renderNode(node, index))}
        </div>
      </CardBody>
    </Card>
  )
}

TLVRenderer.propTypes = {
  nodes: PropTypes.array.isRequired,
  inputHex: PropTypes.string
}

export default TLVRenderer
